import { ServiceBase } from '../../../../../../../core/services/ServiceBase'
import FDIProxy from './proxy'

class FDIService extends ServiceBase {
  getFdiData(params) {
    return this.getData(() => FDIProxy.getFdiData(params))
  }
}

export default new FDIService()
